import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WithdrawnThankYou from 'interview/components/withdrawn-thank-you'
import CandidateServices from 'interview/services/candidate'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { Flex } from 'components/styled/containers/flex'
import { H3 } from 'components/styled/typography'
import { Confirmation } from 'components/styled/modal/confirmation'
import { Button } from 'components/styled/button'

const propTypes = {
  i18n: PropTypes.shape({
    withdraw: PropTypes.shape({
      title: PropTypes.string,
      buttonText: PropTypes.string,
      confirm: PropTypes.string,
    }).isRequired,
  }).isRequired,
  params: PropTypes.shape({
    token: PropTypes.string,
  }).isRequired,
  candidate: PropTypes.shape({
    stage: PropTypes.object,
  }).isRequired,
}

const defaultProps = {
  children: undefined,
}

export function Withdraw({ i18n, params: { token } }) {
  const [confirm, setConfirm] = useState(false)
  const [withdrawn, setWithdrawn] = useState(false)

  const onConfirm = () => {
    setConfirm(false)
    return CandidateServices.withdraw(token).then(() => setWithdrawn(true))
  }

  if (withdrawn) {
    return <WithdrawnThankYou />
  }

  return (
    <Flex alignItems="center" flexDirection="column" mt="s40">
      <H3 mb="s24">{i18n.withdraw.title}</H3>
      <Button
        text={i18n.withdraw.buttonText}
        icon="not_interested"
        variant="secondary"
        onClick={() => setConfirm(!confirm)}
      />
      <Confirmation
        id="withdraw-confirm"
        isOpen={confirm}
        onConfirm={onConfirm}
        onCancel={() => setConfirm(!confirm)}
        body={i18n.withdraw.confirm}
      />
    </Flex>
  )
}

Withdraw.propTypes = propTypes
Withdraw.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(Withdraw)
